import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const toForm = (d) => ({ name: d.name || "", mobile: d.mobile || "", job_role: d.job_role || "", trainer_bio: d.trainer_bio || "" });

export function useMyProfile(onSaved) {
  const { updateUser } = useAuth();
  const [p, setP] = useState(null);
  const [form, setForm] = useState(toForm({}));
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  useEffect(() => {
    api.get("/me/profile").then((r) => { setP(r.data); setForm(toForm(r.data)); }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setPhoto = (photo_url) => { setP((x) => ({ ...x, photo_url })); updateUser({ photo_url }); onSaved?.(); };

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const { data } = await api.put("/me/profile", form);
      setP(data); updateUser({ name: data.name, job_role: data.job_role, trainer_bio: data.trainer_bio, mobile: data.mobile });
      toast.success("Profile saved"); onSaved?.(data);
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file);
    try {
      const { data } = await api.post("/me/photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setPhoto(data.photo_url); toast.success("Photo updated");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const removePhoto = async () => {
    try { await api.delete("/me/photo"); setPhoto(null); toast.success("Photo removed"); }
    catch { toast.error("Could not remove photo"); }
  };

  return { p, form, set, saving, uploading, fileRef, save, upload, removePhoto };
}
